import React, { useState, useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";
import Select from "../../../components/Select";
import Form from './form'
import ReactLoading from "react-loading";
import axios from "axios"
import auth from "../../../utils/auth";
import cfg from "../../../utils/config";
import helper from "../../../utils/helper";

const TemplateModal = ({ showModal, closeModal }) => {
    const userInfo = auth.getUserInfo()

    const [vendor, setVendor] = useState(null)
    const [device, setDevice] = useState(null)
    const [profile, setProfile] = useState(null)

    const [vendorsOptions, setVendorsOptions] = useState([])
    const [devicesOptions, setDevicesOptions] = useState([])
    const [profilesOptions, setProfilesOptions] = useState([])
    const [templateProfile, setTemplateProfile] = useState(null)

    const [isLoading, setIsLoading] = useState(null)

    const getConfig = () => ({
        headers: { 'Authorization': 'Bearer ' + auth.getToken() }
    })

    const getVendors = () => {
        const requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/vendors/`

        axios.get(requestURL, getConfig()).then(({ data }) => {
            const options = data?.results?.map(item => ({
                label: item.name,
                value: item.id
            }))

            setVendorsOptions(options)
        })
    }

    const getDevices = (vendorId) => {
        const requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/vendors/${vendorId}/devices/`

        axios.get(requestURL, getConfig()).then(({ data }) => {
            const options = data?.results?.map(item => ({
                label: item.name,
                value: item.id
            }))

            setDevicesOptions(options)
        })
    }

    const getProfiles = (vendorId, deviceId) => {
        const requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/vendors/${vendorId}/devices/${deviceId}/`

        axios.get(requestURL, getConfig()).then(({ data }) => {
            const options = data?.results?.map(item => ({
                label: item.name,
                value: item.id
            }))

            setProfilesOptions(options)
        })
    }

    const getProfileDetail = (vendorId, deviceId, profileId) => {
        const requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/vendors/${vendorId}/devices/${deviceId}/profile/${profileId}/`

        axios.get(requestURL, getConfig()).then(({ data }) => {
            setTemplateProfile(data)
        })
    }

    const importProfile = async () => {
        const requestURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo.empresa}/lns/vendors/${vendor}/devices/${device}/profile/${profile}/import/`;

        try {
            setIsLoading(true);

            const res = await axios.post(requestURL, {}, getConfig());

            if (res.status === 201) {
                helper.dispatchEvent("showAviso", { message: "Importação realizada com sucesso." });

                handleCloseModal({ isImported: true });
            }
        } catch (error) {
            helper.dispatchEvent("showAviso", { message: "Erro ao importar perfil." });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            getVendors()
        }
    }, [showModal])

    const handleVendorChange = (selected) => {
        const newVendor = selected?.value

        if (vendor === newVendor) return

        setVendor(newVendor)

        setDevice(null)
        setProfile(null)
        setDevicesOptions([])
        setProfilesOptions([])

        if (newVendor) {
            getDevices(newVendor)
        }
    }

    const handleDeviceChange = (selected) => {
        const newDevice = selected?.value

        if (device === newDevice) return

        setDevice(newDevice)

        setProfile(null)
        setProfilesOptions([])

        if (newDevice && vendor) {
            getProfiles(vendor, newDevice)
        }
    }

    const handleProfileChange = (selected) => {
        const newProfile = selected?.value

        if (profile === newProfile) return

        setProfile(newProfile)
        setTemplateProfile(null)

        if (newProfile && vendor && device) {
            getProfileDetail(vendor, device, newProfile)
        }
    }

    const handleCloseModal = ({ isImported = false }) => {
        setVendor(null)
        setDevice(null)
        setProfile(null)
        setTemplateProfile(null)
        closeModal(isImported)
    }

    return (
        <Modal isOpen={showModal} toggle={handleCloseModal} size="lg">
            <ModalBody
                style={{
                    maxHeight: profile ? "70vh" : "auto",
                    overflowY: profile ? "auto" : "visible"
                }}
            >
                {isLoading && (
                    <div className="loading-screen-overlay" style={{ height: '100vh' }}>
                        <ReactLoading
                            type="spin"
                            color="var(--background-menu)"
                            width={50}
                        />
                    </div>
                )}
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <i
                            className="fa fa-info-circle fa-20px"
                            title='Informações do Cadastro de Aplicações'
                            style={{
                                cursor: "pointer",
                                marginRight: '5px',
                                marginTop: '8px',
                            }}
                            onClick={() =>
                                helper.dispatchEvent("showAviso", {
                                    message: `
                                        Define como o dispositivo opera dentro do protocolo LoRa. Crie um perfil para cada linha de dispositivos que você utiliza.<br /><br />
                                        Antes de criar o perfil, identifique o método de autenticação do seu dispositivo:<br /><br />
                                        <strong>OTAA (recomendado)</strong> — O dispositivo negocia as chaves com a rede automaticamente. Você precisará do <strong>DevEUI</strong>, <strong>AppEUI</strong> e <strong>AppKey</strong>.<br /><br />
                                        <strong>ABP</strong> — As chaves são fixas e gravadas diretamente no dispositivo. Você precisará do <strong>DevAddr</strong>, <strong>NwkSKey</strong> e <strong>AppSKey</strong>.<br /><br />
                                        ⚠️ O método escolhido aqui deve ser o mesmo configurado no hardware, pois as chaves exigidas no cadastro mudam conforme o tipo.
                                    `,
                                })
                            }
                        />
                        <h4>Importar Perfil Template</h4>
                        <div className="gray-background">
                            <i className="las fa-hdd la-2x"></i>
                        </div>
                    </span>
                </div>
                <div className="hdv-form-default" style={{ position: "relative", minHeight: "100px" }}>
                    <div className="row">

                        <div className={"col-md-4"}>
                            <label className="required">Fornecedor</label>
                            <Select
                                value={vendor}
                                onChange={handleVendorChange}
                                options={vendorsOptions}
                                resolveValueFromOptions
                            />
                        </div>

                        <div className={"col-md-4"}>
                            <label className="required">Dispositivo</label>
                            <Select
                                value={device}
                                onChange={handleDeviceChange}
                                options={devicesOptions}
                                resolveValueFromOptions
                                disabled={!vendor}
                            />
                        </div>

                        <div className={"col-md-4"}>
                            <label className="required">Perfil</label>
                            <Select
                                value={profile}
                                onChange={handleProfileChange}
                                options={profilesOptions}
                                resolveValueFromOptions
                                disabled={!device}
                            />
                        </div>
                    </div>

                    {profile &&
                        <>
                            <Form
                                isTemplate
                                templateProfile={templateProfile}
                                closeModal={handleCloseModal}
                                importProfile={importProfile}
                                isLoadingImport={isLoading}
                            />
                        </>
                    }
                </div>
            </ModalBody>
        </Modal>
    );
}

export default TemplateModal;